"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shadow = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Fit_1 = require("./Fit");
exports.Shadow = styled_1.default(Fit_1.Fit) `
  border-radius: inherit;
  pointer-events: none;
  box-shadow: ${styled_tools_1.withProp('depth', (d = 2) => `0 ${d * 2}px ${d * 4}px rgba(0, 0, 0, 0.2)`)};

  &&&&&& {
    margin: 0;
  }
`;

//# sourceMappingURL=Shadow.js.map
